module.exports = __webpack_public_path__ + "img/1F4AB.920010a6.svg";